import axios from '@/libs/axios'

export default {
  getCategories() {
    return axios.get('categories')
  },
}
